var _circle, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStudentForDocIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 9,
    cy: 8,
    r: 3,
    stroke: "currentColor",
    strokeWidth: 1.8
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.8 19c.4-3 2.2-4.8 5.2-4.8s4.8 1.8 5.2 4.8",
    stroke: "currentColor",
    strokeWidth: 1.8,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16 6.2a2.6 2.6 0 0 1 0 5.1M16.5 14.3c2.2.5 3.4 2 3.7 4.2",
    stroke: "currentColor",
    strokeWidth: 1.8,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStudentForDocIcon);
export default __webpack_public_path__ + "static/media/studentForDocIcon.a4e4a66a761bd146c7193f917e63c200.svg";
export { ForwardRef as ReactComponent };